import { useSelector } from 'react-redux';
import { getPinnedViewIdsOptimisticUpdates } from '../selectors/pinnedViewsSelectors';
import { usePinnedViewIds } from './usePinnedViewIds';
export const useOptimisticallyUpdatedPinnedViewIds = () => {
  const pinnedViewIds = usePinnedViewIds();
  const optimisticUpdates = useSelector(getPinnedViewIdsOptimisticUpdates);
  return optimisticUpdates || pinnedViewIds;
};